

































import Component from "vue-class-component";
import Vue from "vue";
import {Project} from "../model/interface/project.interface";
import {Collection} from "../model/interface/collection.interface";
import {Prop, Watch} from "vue-property-decorator";
import ProjectHandleComponent from "./project-handle.vue";
import {Observer, Subject} from "../model/interface/subject-observer.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {Author} from "../model/interface/author";
import {WhitelistService} from "../services/whitelist.service";

@Component
export default class AuthorAddComponent extends Vue {
  @Prop(Number) activateDialog!: number;
  @Prop(Number) projectId!: number;
  @Prop(Array) whitelist!: Author[];

  private showDialog: boolean = false;
  private validate: boolean = false;
  private author: Author = <Author>{
    firstName: null,
    lastName: null
  };

  get messageClassCollectionId() {
    return true;
  }

  private async submitAuthor() {
    this.validate = true;

    if (!this.validateString(this.author.firstName) || !this.validateString(this.author.lastName)) {
      return;
    }
    try {
      //Call to API
      const added: Author | false = await WhitelistService.addAuthorToWhitelist(this.projectId, this.author);
      if (added) {
        MessageBus.$emit(AlertType[AlertType.success], `Author ${added.firstName} ${added.lastName} successfully added to Whitelist!`);
        this.whitelist.push(added);
      }
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during author addition! ' + e);
    } finally {
      this.showDialog = false;
      this.author = <Author>{
        firstName: null,
        lastName: null
      };
      this.validate = false;
    }
  }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
  }

  get messageClassFirstName() {
    return {
      'md-invalid': !this.validateString(this.author.firstName) && this.validate
    };
  }

  get messageClassLastName() {
    return {
      'md-invalid': !this.validateString(this.author.lastName) && this.validate
    };
  }

  /**
   * Returns true, if the string is valid (no special characters, length > 2)
   * @param proposed
   */
  private validateString(proposed: string | null): boolean {
    if (!proposed)
      return false;
    return !!(proposed.length > 2 && proposed.match("^[^`~!@#$%^&*()_+={}\\[\\]|\\\\:;“’<,>.?๐฿]*$"));
  }


}
